export enum UserAdministrationStatusTypes {
    INVITED = "invited",
    ACTIVE = "active",
    BLOCKED = "blocked",
}

export type UserAdministrationStatusType =
    | UserAdministrationStatusTypes.INVITED
    | UserAdministrationStatusTypes.ACTIVE
    | UserAdministrationStatusTypes.BLOCKED;

export interface UserAdministrationStatus {
    /* User status type */
    type: UserAdministrationStatusType;
    /* Localized status message */
    text: string;
}

export interface UserAdministrationItem {
    /* Unique identifier for every user and their username */
    eMail: string;
    /* The role that has been assigned to a user */
    userRole: string;
    /* Date of last login */
    lastLogin: string;
    /* Current invitation status */
    status: UserAdministrationStatus;
    /* Link to the users detail page */
    detailLink: string;
}

export interface UserAdministrationResponse {
    /* API endpoint form requesting further results */
    nextPage?: string | null;
    /* The total number of results */
    totalCount: number;
    /* The number of results with current filter applied */
    filteredCount: number;
    /* Markup for the filters */
    filterHTML?: string | null;
    /* The result items */
    items: UserAdministrationItem[];
}
